<div class="main">
    <router-outlet #manageOutlet="outlet"></router-outlet>
</div>
